import * as React from "react";
import { BarChart } from '@mui/x-charts';

const StackedBarChart = ({ chart_data, isFullWidth }) => {

    const { chartType, type, chart_type, xAxis, yAxis, daily, weekly, data } = chart_data;
    const chartViewType = chartType || type || chart_type;
    const isMultipleTabs = daily && weekly;

    const getQuestionChartData = () => {
        const questions = data?.map((d) => d?.question);
        const correct = data?.map((d) => d?.correct);
        const incorrect = data?.map((d) => d?.incorrect);

        const questionsSeries = { data: questions, label: xAxis }
        const correctSeries = { data: correct, label: "Correct",color: '#79c97a', }
        const incorrectSeries = { data: incorrect, label: "Incorrect", color: '#ff6d6d', }


        return { questionsSeries, correctSeries, incorrectSeries };
    };

    const getCategoryContestFillRateChartData = () => {
        const category = data?.map((d) => d?.category);
        const instant = data?.map((d) => d?.instant);
        const under1min = data?.map((d) => d?.under1min);
        const _1to5min = data?.map((d) => d?.["1to5min"]);
        const over5min = data?.map((d) => d?.over5min);

        const categorySeries = { data: category, label: xAxis }
        const instantSeries = { data: instant, label: "Instant" }
        const under1minSeries = { data: under1min, label: "Under 1 Minute" }
        const _1to5minSeries = { data: _1to5min, label: "Under 1 to 5 Minutes" }
        const over5minSeries = { data: over5min, label: "Over 5 Minutes" }

        return { categorySeries, instantSeries, under1minSeries, _1to5minSeries, over5minSeries };
    };

    const { categorySeries, instantSeries, under1minSeries, _1to5minSeries, over5minSeries, questionsSeries, correctSeries, incorrectSeries } = (xAxis?.toLowerCase() === 'questions' ? getQuestionChartData() : getCategoryContestFillRateChartData());

    const getSeries = () => {
        if (xAxis?.toLowerCase() === 'questions') {
            return [{ ...incorrectSeries, stack: 'total' },
            { ...correctSeries, stack: 'total' }]
        }
        else {
            return [{ ...instantSeries, stack: 'total' },
            { ...under1minSeries, stack: 'total' },
            { ..._1to5minSeries, stack: 'total' },
            { ...over5minSeries, stack: 'total' }]
        }
    }

    const getXAxis = () => {
        if (xAxis?.toLowerCase() === 'questions') {
            return questionsSeries;
        }
        else {
            return categorySeries;
        }
    }

    return (
        <div style={isFullWidth ? styles.cardFull : styles.cardHalf}>
            <h3>{chart_data?.title || chart_data?.chart_name}</h3>
            <p>{chart_data?.description}</p>
            <BarChart
                xAxis={[
                    {
                        ...getXAxis(),
                        tickLabelStyle: {
                            angle: 0,
                            dominantBaseline: 'central',
                            textAnchor: 'middle',
                        },
                        height: 50,
                    },
                ]}
                yAxis={[{ min: 0, max: 100 }]}
                series={getSeries()}
                height={380}
            />
        </div>
    );

}

const styles = {
    cardHalf: {
        flex: 0.48,
        padding: 20,
        border: '1px solid #ccc',
        borderRadius: '12px',
        boxShadow: '0px 2px 8px rgba(0,0,0,0.1)',
        textAlign: 'left',
    },
    cardFull: {
        flex: 1,
        padding: 20,
        border: '1px solid #ccc',
        borderRadius: '12px',
        boxShadow: '0px 2px 8px rgba(0,0,0,0.1)',
        textAlign: 'left',
    },
};

export default StackedBarChart;